const Facturacion = () => {
	return <div>Facturación</div>;
};

export default Facturacion;
